var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5C15.5073 4.94776 15.5073 4.89475 15.5 4.8425V4.7825C15.4871 4.74064 15.4695 4.70038 15.4475 4.6625C15.4378 4.6409 15.4251 4.62072 15.41 4.6025L15.335 4.505L15.275 4.46L15.185 4.3925L8.435 0.642504C8.32099 0.576677 8.19165 0.542023 8.06 0.542023C7.92835 0.542023 7.79901 0.576677 7.685 0.642504L0.935 4.3925L0.8675 4.445L0.785 4.505C0.763211 4.52953 0.745487 4.55738 0.7325 4.5875C0.708504 4.60903 0.688231 4.63437 0.6725 4.6625C0.653026 4.69541 0.6379 4.73071 0.6275 4.7675C0.623304 4.79233 0.623304 4.81768 0.6275 4.8425C0.575934 4.88697 0.532752 4.94031 0.5 5V11C0.500973 11.1336 0.537641 11.2646 0.606209 11.3793C0.674776 11.494 0.772752 11.5884 0.89 11.6525L7.64 15.4025C7.67099 15.4206 7.70364 15.4356 7.7375 15.4475H7.8125C7.93571 15.4774 8.06429 15.4774 8.1875 15.4475H8.2625L8.3675 15.4025L15.1175 11.6525C15.2333 11.5874 15.3298 11.4927 15.397 11.378C15.4642 11.2634 15.4998 11.1329 15.5 11V5ZM8 7.9025L2.795 5L4.865 3.86L9.9875 6.785L8 7.9025ZM8 2.1125L13.205 5L11.525 5.9375L6.4025 3.005L8 2.1125ZM2 6.275L7.25 9.215V13.475L2 10.5575V6.275ZM8.75 13.475V9.215L11 7.955V10.25L12.5 9.5V7.115L14 6.2825V10.5575L8.75 13.475Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.4761bef49566488bf939d965a1f8d2c8.svg";
export { ForwardRef as ReactComponent };